module.exports = __webpack_public_path__ + "static/media/Bronze_Badge.dc2a64de.zip";